var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"couponBox"},[_c('div',{style:({width: '100px', height: '100px', backgroundImage: `url(${_vm.image.startsWith('http') ? _vm.image : _vm.image.replace('^/', '')})`,
  backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', borderRadius: '5px',
  backgroundColor: '#CACACA'})}),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"toolong",style:({
      color: 'var(--color-pri)',
      fontSize: '17px',
      fontWeight: '700'
    }),attrs:{"label":"活動名稱: "}},[_vm._v(_vm._s(_vm.couponName))]),_c('div',{staticClass:"toolong",style:({
      color: 'var(--color-checked)',
      fontSize: '18px',
      fontWeight: '400',
      marginBottom: '6px'
    }),attrs:{"label":"贈品名稱: "}},[_vm._v(_vm._s(_vm.productName))]),_c('div',{staticClass:"date"},[_vm._v("開始日期: "+_vm._s(_vm.start))]),_c('div',{staticClass:"date"},[_vm._v("有效期限: "+_vm._s(_vm.expire))])]),_c('button',{on:{"click":function($event){return _vm.$emit('selectThis')}}},[(_vm.icon==='select')?_c('iconPlus'):(_vm.icon==='delete')?_c('iconDelete',{attrs:{"color":"#E37878","color2":"transparent"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }